<template>
  <div class="shpksh-container">
    <el-row class="tcf-row">
      <el-col  class="card">
        <div class="card-body">
          <el-form :inline="true" size="small" :model="searchForm" @submit.native.prevent>
            <el-form-item label="审核状态">
              <el-select v-model="searchForm.type" style="width: 120px" @keyup.enter.native="Search" filterable clearable>
                <el-option label="待审核" :value="1" />
                <el-option label="审核通过" :value="2" />
                <el-option label="审核拒绝" :value="0" />
              </el-select>
            </el-form-item>
            <el-form-item label="审核时间">
              <el-date-picker
                v-model="searchForm.auitTimes"
                type="daterange"
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                format="yyyy-MM-dd"
                value-format="yyyy-MM-dd">
              </el-date-picker>
            </el-form-item>
            <el-form-item label="余额区间">
              <el-input v-model="searchForm.bs" oninput ="value=value.replace(/[^0-9.]/g,'')" style="width: 140px"
                placeholder="最小余额"><template slot="append">元</template></el-input>
              ~
              <el-input v-model="searchForm.be" oninput ="value=value.replace(/[^0-9.]/g,'')" style="width: 140px"
                placeholder="最大余额"><template slot="append">元</template></el-input>
            </el-form-item>
            <el-form-item label="搜索关键字">
              <el-input v-model="searchForm.search" placeholder="关键字搜索" @keyup.enter.native="Search"></el-input>
            </el-form-item>
            <el-form-item>
              <el-button icon="el-icon-search" @click="Search">搜索</el-button>
            </el-form-item>
            <el-form-item>
              <el-button :loading="btnLoading" icon="el-icon-printer" @click="exportExcel">导出Excel</el-button>
            </el-form-item>
          </el-form>
          <div class="card-content" >
            <el-row>
              <el-col :span="24" v-loading="loading">
                <el-table
                  :data="tableData"
                  stripe
                  @row-click="openDetails"
                  :row-style="{cursor: 'pointer'}"
                  style="width: 100%">
                  <el-table-column
                    label="赔款名称"
                    min-width="150"
                    show-overflow-tooltip>
                    <template slot-scope="scope">
                      <span>{{scope.row.name}}</span>
                    </template>
                  </el-table-column>
                  <el-table-column
                    label="经销商"
                    width="120"
                    show-overflow-tooltip>
                    <template slot-scope="scope">
                      <span>{{scope.row.delname}}</span>
                    </template>
                  </el-table-column>
                  <el-table-column
                    label="关联订单"
                    width="140"
                    align="center"
                    show-overflow-tooltip>
                    <template slot-scope="scope">
                      <span v-if="scope.row.orderid" style="cursor: pointer; color: #409EFF;" @click.stop="toOrderDteail(scope.row)">{{scope.row.orderNumber}}</span>
                      <span v-else style="color: #999999;">--</span>
                    </template>
                  </el-table-column>
                  <el-table-column
                    label="赔款总额"
                    width="100"
                    align="center"
                    show-overflow-tooltip>
                    <template slot-scope="scope">
                      <span style="color:#409EFF;font-weight: 500;">{{scope.row.amount}}</span>
                    </template>
                  </el-table-column>
                  <el-table-column
                    label="江山生态工厂承担"
                    width="80"
                    align="center"
                    show-overflow-tooltip>
                    <template slot-scope="scope">
                      <span style="color:#409EFF;font-weight: 500;">{{scope.row.factory||0}}</span>
                    </template>
                  </el-table-column>
                  <el-table-column
                    label="浙江首造工厂承担"
                    width="80"
                    align="center"
                    show-overflow-tooltip>
                    <template slot-scope="scope">
                      <span style="color:#409EFF;font-weight: 500;">{{scope.row.factory1||0}}</span>
                    </template>
                  </el-table-column>
                  <el-table-column
                    label="拆单承担"
                    width="80"
                    align="center"
                    show-overflow-tooltip>
                    <template slot-scope="scope">
                      <span style="color:#409EFF;font-weight: 500;">{{scope.row.design||0}}</span>
                    </template>
                  </el-table-column>
                  <el-table-column
                    label="营销承担"
                    width="80"
                    align="center"
                    show-overflow-tooltip>
                    <template slot-scope="scope">
                      <span style="color:#409EFF;font-weight: 500;">{{scope.row.marketing||0}}</span>
                    </template>
                  </el-table-column>
                  <el-table-column
                    label="建模承担"
                    width="80"
                    align="center"
                    show-overflow-tooltip>
                    <template slot-scope="scope">
                      <span style="color:#409EFF;font-weight: 500;">{{scope.row.modeling||0}}</span>
                    </template>
                  </el-table-column>
                  <el-table-column
                    label="余额"
                    width="90"
                    align="center"
                    show-overflow-tooltip>
                    <template slot-scope="scope">
                      <span style="color:#409EFF;font-weight: 500;">{{scope.row.balance}}</span>
                    </template>
                  </el-table-column>
                  <el-table-column
                    label="抵款方式"
                    width="110"
                    align="center"
                    show-overflow-tooltip>
                    <template slot-scope="scope">
                      <span v-if="scope.row.credit===0">最高冲抵{{scope.row.maximpact}}%</span>
                      <span v-if="scope.row.credit===9">任意冲抵</span>
                    </template>
                  </el-table-column>
                  <el-table-column
                    label="申请人"
                    width="110"
                    align="center"
                    show-overflow-tooltip>
                    <template slot-scope="scope">
                      {{scope.row.username}}
                    </template>
                  </el-table-column>
                  <el-table-column
                    label="申请时间"
                    width="145"
                    show-overflow-tooltip>
                    <template slot-scope="scope">
                      <span>{{scope.row.time}}</span>
                    </template>
                  </el-table-column>
                  <el-table-column
                    label="审核时间"
                    width="145"
                    show-overflow-tooltip>
                    <template slot-scope="scope">
                      <span>{{scope.row.audittime}}</span>
                    </template>
                  </el-table-column>
                  <el-table-column
                    label="审核状态"
                    width="110"
                    align="center"
                    fixed="right"
                    show-overflow-tooltip>
                    <template slot-scope="scope">
                      <el-tag :disable-transitions="true" size="mini" v-if="scope.row.mark===1" type="warning">待审核</el-tag>
                      <el-tag :disable-transitions="true" size="mini" v-if="scope.row.mark===2">审核通过</el-tag>
                      <el-tag :disable-transitions="true" size="mini" v-if="scope.row.mark===0" type="danger">审核拒绝</el-tag>
                    </template>
                  </el-table-column>
                  <el-table-column
                    width="120"
                    align="center"
                    fixed="right"
                    label="操作"
                  >
                    <template slot-scope="scope">
                      <el-button v-if="scope.row.mark===2" icon="el-icon-document" size="mini" @click.stop="viewAfterRecord(scope.row)">使用记录</el-button>
                    </template>
                  </el-table-column>
                </el-table>
                <el-pagination
                  v-if="total>0"
                  background
                  @size-change="handleSizeChange"
                  @current-change="handleCurrentChange"
                  :current-page="currentPage"
                  :page-sizes="[20, 50, 100]"
                  :page-size="pageSize"
                  layout="total, sizes, prev, pager, next, jumper"
                  :total="total">
                </el-pagination>
              </el-col>
            </el-row>
          </div>
        </div>
      </el-col>
    </el-row>
    <el-dialog
      title="售后赔款/划帐详情"
      :visible.sync="viewVisible"
      width="40%"
      :destroy-on-close="true"
      :lock-scroll="true"
      :append-to-body="true">
      <table class="tcf-detail-table" v-loading="viewLoading">
        <tr>
          <th>申请人</th>
          <td>{{ viewdata.username }}</td>
          <th>申请时间</th>
          <td colspan="3">{{ viewdata.time }}</td>
        </tr>
        <tr>
          <th>经销商</th>
          <td>{{ viewdata.delname }}</td>
          <th>关联订单</th>
          <td colspan="3">
            <span v-if="viewdata.orderid" style="color:#409EFF; cursor: pointer;" @click="toOrderDteail(viewdata)">{{ viewdata.orderNumber }}</span>
            <span v-else style="color: #999999;">--</span>
          </td>
        </tr>
        <tr>
          <th>赔款名称</th>
          <td colspan="4" style="color:#000;">{{ viewdata.name }}</td>
        </tr>
        <tr>
          <th>类型</th>
          <td colspan="3" v-if="viewdata.type===0" style="color:#000;">售后赔款</td>
          <td colspan="3" v-if="viewdata.type===1" style="color:#000;">划帐</td>
        </tr>
        <tr>
          <th>江山生态工厂承担</th>
          <td style="color:#409EFF;font-weight: 500;"><i class="el-icon-coin"></i> {{ viewdata.factory || 0 }}</td>
          <th>浙江首造工厂承担</th>
          <td colspan="3" style="color:#409EFF;font-weight: 500;"><i class="el-icon-coin"></i> {{ viewdata.factory1 || 0 }}</td>
        </tr>
        <tr>
          <th>拆单承担</th>
          <td style="color:#409EFF;font-weight: 500;"><i class="el-icon-coin"></i> {{ viewdata.design || 0 }}</td>
          <th>营销承担</th>
          <td style="color:#409EFF;font-weight: 500;"><i class="el-icon-coin"></i> {{ viewdata.marketing || 0 }}</td>
          <th>建模承担</th>
          <td style="color:#409EFF;font-weight: 500;"><i class="el-icon-coin"></i> {{ viewdata.modeling || 0 }}</td>
        </tr>
        <tr>
          <th>赔款总额</th>
          <td style="color:#409EFF;font-weight: 500;"><i class="el-icon-coin"></i> {{ viewdata.amount }}</td>
          <th>抵款方式</th>
          <td colspan="3">
            <span v-if="viewdata.credit===0">最高冲抵{{viewdata.maximpact}}%</span>
            <span v-if="viewdata.credit===9">任意冲抵</span>
          </td>
        </tr>
        <tr>
          <th>余额</th>
          <td style="color:#409EFF;font-weight: 500;"><i class="el-icon-coin"></i> {{ viewdata.balance }}</td>
        </tr>
        <tr>
          <th>适用订单</th>
          <td>
            <span v-if="viewdata.ordertype===0">无限制</span>
            <span v-if="viewdata.ordertype===1">正单</span>
            <span v-if="viewdata.ordertype===2">补单</span>
          </td>
          <td colspan="4">
            订单金额满 {{viewdata.orderMoney}} 元以上可冲抵
          </td>
        </tr>
        <tr>
          <th>赔款凭证</th>
          <td colspan="5">
            <el-image v-for="iurl in imgSrcList"
                      style="width: 60px; height: 60px;margin-right: 10px;margin-bottom: 10px"
                      :src="iurl"
                      :preview-src-list="imgSrcList">
            </el-image>
          </td>
        </tr>
        <tr>
          <th>备注说明</th>
          <td colspan="5">{{ viewdata.remark }}</td>
        </tr>
        <tr  v-if="viewdata.mark===0||viewdata.mark===2">
          <th>审核人</th>
          <td>{{ viewdata.auditname }}</td>
          <th>审核时间</th>
          <td colspan="3">{{ viewdata.audittime }}</td>
        </tr>
        <tr v-if="viewdata.mark===0">
          <th>驳回原因</th>
          <td colspan="5">{{ viewdata.rson }}</td>
        </tr>
        <tr v-if="viewdata.mark===1&&viewdata.rson!=''&&viewdata.rson!=null">
          <th>上次驳回</th>
          <td colspan="5" style="color:#f56c6c">{{ viewdata.rson }}</td>
        </tr>
      </table>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" v-if="viewdata.mark===1" :loading="auditLoading" size="small" @click="audit(1)">审核通过</el-button>
        <el-button type="danger" v-if="viewdata.mark===1" :loading="auditLoading" size="small" @click="audit(0)">审核驳回</el-button>
        <el-button size="small" @click="viewVisible = false">关闭</el-button>
      </span>
    </el-dialog>

    <el-dialog
      :title="receiptAccountTitle"
      :visible.sync="receiptAccountVisible"
      width="65%"
      :destroy-on-close="true"
      :lock-scroll="true"
      :append-to-body="true"
    >
      <el-table
        v-loading="receiptAccountLoading"
        :data="receiptAccountTableData"
        border
        height="400"
        size="small"
        style="width: 100%"
      >
        <el-table-column
          prop="time"
          align="center"
          label="使用时间"
          width="170"
        />
        <el-table-column
          prop="username"
          align="center"
          label="操作人"
          width="80"
        />
        <el-table-column
          width="100"
          align="center"
          label="生产单号"
        >
          <template slot-scope="scope">
            <span style="color:#409EFF;font-weight: 500;">{{ scope.row.produnum }}</span>
          </template>
        </el-table-column>
        <el-table-column
          width="100"
          align="center"
          label="使用类型"
        >
          <template slot-scope="scope">
            <el-tag v-if="scope.row.opertype===0" :disable-transitions="true" size="mini" type="warning">订单报价</el-tag>
            <el-tag v-if="scope.row.opertype===1" :disable-transitions="true" size="mini">订单收款</el-tag>
          </template>
        </el-table-column>
        <el-table-column
          width="100"
          align="center"
          label="优惠折扣"
        >
          <template slot-scope="scope">
            <span v-if="scope.row.type===2&&scope.row.opertype===0">{{ scope.row.discount }}</span>
            <span v-if="scope.row.type===2&&scope.row.opertype!==0">N/A</span>
            <span v-if="scope.row.type===0||scope.row.type===1||scope.row.type===5">N/A</span>
          </template>
        </el-table-column>
        <el-table-column
          width="100"
          align="center"
          label="使用金额"
        >
          <template slot-scope="scope">
            <span v-if="scope.row.type===0||scope.row.type===1||scope.row.type===5||(scope.row.type===2&&scope.row.opertype!==0)" style="color:#409EFF;font-weight: 500;">{{ scope.row.money }}</span>
            <span v-if="scope.row.type===2&&scope.row.opertype===0">N/A</span>
          </template>
        </el-table-column>
        <el-table-column
          min-width="100"
          align="center"
          label="收款内容"
        >
          <template slot-scope="scope">
            <span v-if="scope.row.opertype!==0">{{ scope.row.paycontent }}</span>
            <span v-if="scope.row.type===2&&scope.row.opertype===0">报价优惠{{ scope.row.money }}元</span>
            <span v-if="scope.row.type===0&&scope.row.opertype===0">报价优惠</span>
          </template>
        </el-table-column>
        <el-table-column
          width="140"
          align="center"
          fixed="right"
          label="订单号"
        >
          <template slot-scope="scope">
            <span style="color:#409EFF;cursor: pointer" @click="goOrder(scope.row.orderid)"><i class="el-icon-document" /> {{ scope.row.ordernum }}</span>
          </template>
        </el-table-column>
      </el-table>
    </el-dialog>
  </div>
</template>

<script>
import { getUser } from '@/utils/auth'
import { getDealerAccountAfterApplyList, excelDealerAccountAfterApplyList, getDealerAccountAfterById, reviewDealerAccountAfter, getDealerReceiptAccountList } from '@/api/erp'

export default {
  name: 'shpksh',
  computed: {
    user: getUser
  },
  data() {
    return {
      searchForm: {
        search: '',
        auitTimes: [],
        st: '',
        et: '',
        bs: '',
        be: '',
        type: null
      },
      btnLoading: false,
      viewVisible: false,
      viewLoading: false,
      imgSrcList: [],
      viewdata: [],
      loading: false,
      tableData: [],
      currentPage: 1,
      pageSize: 20,
      total: 0,
      auditLoading: false,
      receiptAccountTitle: '',
      receiptAccountVisible: false,
      receiptAccountLoading: false,
      receiptAccountTableData: [],
      receiptAccountType: 0,
      receiptAccountDataid: null,
    }
  },
  created() {
    this.getData()
  },
  methods: {
    Search() {
      this.searchForm.st = ''
      this.searchForm.et = ''
      if (this.searchForm.auitTimes && this.searchForm.auitTimes.length == 2) {
        this.searchForm.st = this.searchForm.auitTimes[0]
        this.searchForm.et = this.searchForm.auitTimes[1]
      }
      this.currentPage = 1
      this.getData()
    },
    getData() {
      this.loading = true
      const data = {
        mark: this.searchForm.type,
        content: this.searchForm.search,
        st: this.searchForm.st || null,
        et: this.searchForm.et || null,
        bs: this.searchForm.bs || null,
        be: this.searchForm.be || null,
        page: this.currentPage,
        limit: this.pageSize,
        groupid: this.user.dGroupid
      }
      getDealerAccountAfterApplyList(data).then(response => {
        this.loading = false
        this.tableData = response.data
        this.total = response.total
      }).catch(() => {
        this.loading = false
      })
    },
    handleSizeChange(val) {
      this.pageSize = val
      this.getData()
    },
    handleCurrentChange(val) {
      this.currentPage = val
      this.getData()
    },
    toOrderDteail(row) {
      this.$router.push({
        path: '/work/order/' + row.orderid
      });
    },
    goOrder(orderid) {
      this.receiptAccountVisible = false
      this.$router.push({ path: '/work/order/' + orderid })
    },
    viewAfterRecord(row) {
      this.receiptAccountTitle = row.name
      this.receiptAccountType = 1
      this.receiptAccountDataid = row.daaid
      this.getDealerReceiptAccount()
    },
    getDealerReceiptAccount() {
      this.receiptAccountVisible = true
      this.receiptAccountLoading = true
      const data = {
        type: this.receiptAccountType,
        dataid: this.receiptAccountDataid
      }
      getDealerReceiptAccountList(data).then(response => {
        this.receiptAccountTableData = response.data
        this.receiptAccountLoading = false
      }).catch(() => {
        this.receiptAccountLoading = false
      })
    },
    openDetails(row) {
      this.imgSrcList = []
      this.viewVisible = true
      this.viewLoading = true
      getDealerAccountAfterById({ daaid: row.daaid }).then(response => {
        this.viewLoading = false
        this.viewdata = response.data.daa
        let imgs = []
        for (let c of response.data.imgs) {
          imgs.push(c.img_url)
        }
        this.imgSrcList = imgs
      }).catch(() => {
        this.viewLoading = false
      })
    },
    audit(n) {
      if (this.auditLoading) {
        return false
      }
      if (n === 0) {
        this.$prompt('请输入驳回原因', '审核驳回-售后赔款/划帐申请', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          inputPattern: /\S/,
          inputErrorMessage: '驳回原因不可为空'
        }).then(({ value }) => {
          this.auditLoading = true
          reviewDealerAccountAfter({ userid: this.user.dUserid, daaid: this.viewdata.daaid, ispass: n, reason: value }).then(response => {
            this.auditLoading = false
            this.viewVisible = false
            this.$message({
              message: '售后赔款申请/划帐已驳回',
              type: 'success'
            })
            this.getData()
          }).catch(() => {
            this.auditLoading = false
          })
        }).catch(() => {})
      } else {
        this.$confirm('此操作将通过此次售后赔款/划帐申请?', '审核通过-售后赔款/划帐申请', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.auditLoading = true
          reviewDealerAccountAfter({ userid: this.user.dUserid, daaid: this.viewdata.daaid, ispass: n }).then(response => {
            this.auditLoading = false
            this.viewVisible = false
            this.$message({
              message: '售后赔款审核/划帐已通过',
              type: 'success'
            })
            this.getData()
          }).catch(() => {
            this.auditLoading = false
          })
        }).catch(() => {})
      }
    },

    exportExcel() {
      this.searchForm.st = ''
      this.searchForm.et = ''
      if (this.searchForm.auitTimes && this.searchForm.auitTimes.length == 2) {
        this.searchForm.st = this.searchForm.auitTimes[0]
        this.searchForm.et = this.searchForm.auitTimes[1]
      }
      const data = {
        mark: this.searchForm.type,
        content: this.searchForm.search,
        st: this.searchForm.st || null,
        et: this.searchForm.et || null,
        bs: this.searchForm.bs || null,
        be: this.searchForm.be || null,
        // userid: this.user.dUserid,
        groupid: this.user.dGroupid
      }
      this.btnLoading = true
      let file = null
      excelDealerAccountAfterApplyList(data).then(response => {
        file = response.data
        this.downLoad(file)
        this.btnLoading = false
      }).catch(() => {
        this.btnLoading = false
      })
    },
    downLoad(file) {
      const _this = this
      let xhr = new XMLHttpRequest()
      xhr.open('GET', file.dPath, true)
      xhr.responseType = 'blob'
      xhr.onload = function() {
        if (this.status === 200) {
          let blob = this.response
          let a = document.createElement('a')
          a.download = file.dName
          a.href = window.URL.createObjectURL(blob)
          a.target = '_blank'
          a.click()
          _this.excelLoading = false
          const h = _this.$createElement
          _this.$msgbox({
            title: '下载提示',
            message: h('div', { attrs: { style: 'letter-spacing:1px;padding-left: 15px;line-height: 22px;' }}, [
              h('span', null, `文件已下载，如文件未下载成功，请关闭相应浏览器拦截，`),
              h('a',
                { attrs: {
                  href: window.URL.createObjectURL(blob),
                  target: '_blank',
                  download: `${file.dName}`,
                  style: 'color: #409EFF;text-decoration:underline;'
                }}, `点击这里`),
              h('span', null, `重新下载。`)
            ]),
            showCancelButton: false,
            confirmButtonText: '关闭',
            beforeClose: (action, instance, done) => {
              done()
            }
          }).then(action => {
          })
        }
      }
      xhr.send()
    },

  }
}
</script>

<style lang="scss" scoped>
.shpksh-container {
  .tcf-row{
    .card{
      .card-body{
        .card-title{
          .add-btn{
            position: relative;
            float: right;
            margin-left: 10px;
            margin-top: -10px;
          }
          .search-mode{
            width: 300px;
            position: relative;
            float: right;
            margin-top: -10px;
            .search-input{
              background-color: #F2F6FC;
              border:0;
              height: 40px;
              line-height: 40px;
              border-radius: 4px;
              color: #606266;
              padding: 0 40px 0 15px;
              -webkit-appearance: none;
              font-size: 12px;
              width: 100%;
              -webkit-box-sizing: border-box;
              box-sizing: border-box;
              outline: 0;
              &::-webkit-input-placeholder {
                color: #C0C4CC;
              }
              &::-ms-input-placeholder {
                color: #C0C4CC;
              }
            }
            .search-btn{
              position: absolute;
              right: 0;
              height: 40px;
              width: 40px;
              line-height: 40px;
              top: 0;
              border: 0;
              background: transparent;
              text-align: center;
              padding: 0;
            }
          }
        }
        .card-content{
          .group-filter{
            width: 100%;
            padding: 0 30px 0 0 ;
            margin: 0 ;
            position: relative;
            li{
              width: 100%;
              list-style: none;
              position: relative;
              padding-left: 20px;
              padding-top: 15px;
              padding-bottom: 15px;
              cursor: pointer;
              border-radius: 2px;
              text-overflow: ellipsis;
              overflow: hidden;
              white-space: nowrap;
              &.active{
                background: #f5f7fa;
                color:#409EFF;
              }
              &:hover{
                color:#409EFF;
              }
            }
          }
          .client-sex{
            width: 16px!important;
            height: 16px!important;
            vertical-align: -4px!important;
          }
          .el-table::before{
            height: 0!important;
          }
          .el-pagination{
            margin-top: 20px;
          }
        }
      }
    }
  }
}
</style>
